import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Select } from "antd";
import { isMobile } from "@/extensions/design";
import PaymentsList from "./payments-list"
import Tickets from "./tickets"
import PaymentsFilter from "./payments-filter";

const Payments = ({page}) => {
  const [showFilter, setShowFilter] = useState(false);
  const [filter, setFilter] = useState();
  const [items, setItems] = useState([]);
  const navigate = useNavigate();

  const pages = [
    { title: "Платежи", link: "payments" },
    { title: "Чеки", link: "tickets"}
  ];

  const getPage = () => {
    switch (page) {
      case "payments": return <PaymentsList externalFilter={filter}/>;
      case "tickets": return <Tickets externalFilter={filter}/>;
      default: return null;
    }
  }
  
  const handlePageChange = (newPage) => {
    if (isMobile) {
      setFilter(undefined);
    }
    navigate(`/${newPage}`);
  };

  const getItem = (title, link) => <a className={"col-one-title-item" + (link === page ? " col-one-title-selected " : "")} href={"/" + link}>{title}</a>

  return !isMobile ? <div className="col-one-main sport-form-content">
    <div className="col-one-title">
      {getItem("Платежи", "payments")}
      {getItem("Чеки", "tickets")}
    </div>
    <div className="col-one-col">{getPage()}</div>
  </div> : (
  <div className="sport-form-content">
    <div className="col-one-main">
      <div className="col-one-col">
        
        {/* <div className='selector-filer-section'>
          <Select value={page} onChange={handlePageChange} style={{width: "100%"}}>
            {pages.map(p => (
              <Select.Option key={p.link} value={p.link}>
                {p.title}
              </Select.Option>
            ))}
          </Select>
          <img src="/images/filter.svg" className="mobile-top-img" alt="filter" onClick={() => setShowFilter(true)}/>
          {showFilter && <PaymentsFilter items={items} value={filter} activePage={page} onClose={(filters) => { setShowFilter(false); if (filters) setFilter(filters); }}/>}
        </div> */}


        <div className="col-one-title-upper-menu">
          <div style={{ fontWeight: 600, fontSize: 16, margin: 8 }}>Оплаты</div>
          <div className="rounded-search-field" style={{padding: "0px", height: "35px"}}>
            <Select value={page} onChange={handlePageChange} style={{ paddingLeft: "16px", borderRadius:"100px", width: "100%", minHeight: "35px" }} className="rounded-search-field custom-select-field" >
              {pages.map(p => (
                <Select.Option key={p.link} value={p.link}>
                  {p.title}
                </Select.Option>
              ))}
            </Select>
            {/* <Input placeholder="Поиск" value={searchText} onChange={(e) => onSearchChange(e.target.value)} allowClear className="search-str" style={{ paddingLeft: "16px", borderRadius:"100px", width: "100%", minHeight: "35px" }}/> */}
          </div>
          <div className="rounded-filter-button" onClick={() => setShowFilter(true)}>
            <img src="/images/filter.svg" className="mobile-top-img" alt="filter" style={{ width: "20px", height: "20px" }} />
          </div>
        </div>
        {showFilter && <PaymentsFilter items={items} value={filter} activePage={page} onClose={(filters) => { setShowFilter(false); if (filters) setFilter(filters); }}/>}
        {getPage()}
      </div>
    </div>
  </div>
  )
}

export default Payments;